const AdminSearchEmptyState = ({
  hasResults,
  hasFilters,
  isLoading,
}: {
  hasResults: boolean;
  hasFilters: boolean;
  isLoading?: boolean;
}) => {
  let emptyTableMessage = "";

  if (isLoading) {
    emptyTableMessage = "Searching...";
  } else if (hasResults) {
    if (hasFilters) {
      emptyTableMessage = "Enter a search term or select filters to begin searching";
    } else {
      emptyTableMessage = "Enter a search term to begin searching";
    }
  } else {
    if (hasFilters) {
      emptyTableMessage = "Nothing was found for the search term and selected filters";
    } else {
      emptyTableMessage = "Nothing was found for the search term";
    }
  }
  return <h3 className="p-2 text-center font-semibold">{emptyTableMessage}</h3>;
};

export default AdminSearchEmptyState;
